var _defs, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUdsmediaassets77(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M73.15,64.75c.2,.12,.48,.23,.68,.43,3.09,3.06,6.18,6.12,9.24,9.21,3.04,3.08,2.38,7.88-1.32,9.88-2.42,1.31-5.29,.84-7.4-1.25-3.07-3.04-6.12-6.11-9.17-9.17-.2-.2-.33-.46-.49-.69-8.1,5.21-16.67,6.76-25.82,4.44-7.61-1.93-13.65-6.26-18.19-12.67-8.84-12.48-7.19-30.03,3.81-40.77,11.28-11.01,28.58-12.22,41.2-2.98,12.56,9.2,17.72,28.03,7.45,43.56Zm-26.37,7.47c14.04,.02,25.43-11.32,25.45-25.35,.03-14.05-11.3-25.44-25.33-25.48-14.07-.04-25.48,11.33-25.49,25.39-.01,14.04,11.33,25.42,25.37,25.44Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.69,34.14h6.26v25.34h-6.26v-25.34Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.94,40.5h6.27v18.96h-6.27v-18.96Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.41,46.82h6.28v12.64h-6.28v-12.64Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUdsmediaassets77);
export default __webpack_public_path__ + "static/media/UDS MEDIA ASSETS-77.532f2b67f44ecf7ce6092be7ac93acfb.svg";
export { ForwardRef as ReactComponent };